import { useMutation } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { useInvalidateBulkImports } from "../invalidate/useInvalidateBulkImports";
import { uploadFileToS3 } from "./uploadFileToS3";

type UploadCallbacks = {
  onUploadProgress?: (progress: number) => void;
};

export const useCreateProfilePhotosImportMutation = () => {
  const { apiClient } = useTacticHooks();
  const invalidateBulkImports = useInvalidateBulkImports();

  return useMutation({
    mutationFn: async ({
      file,
      onUploadProgress
    }: { file: File } & UploadCallbacks) => {
      const uploadRes =
        await apiClient.bulkImports.createUpload("profile_photos");
      if (!uploadRes.ok || !uploadRes.result) {
        throw uploadRes;
      }
      const { upload_url, s3_path } = uploadRes.result;
      await uploadFileToS3(upload_url, file, "application/zip", onUploadProgress);
    
      const importRes =
        await apiClient.bulkImports.createProfilePhotosImport(s3_path);
      if (!importRes.ok || !importRes.result) {
        throw importRes;
      }
      return importRes.result;
    },
    onSuccess: async () => {
      await invalidateBulkImports();
    }
  });
};
